import { removeDupes, cleanObject } from '../utils/helpers';

const rules = (state = {
    items: []
}, action) => {
    if (action.error) {
        return state;
    }

    switch (action.type) {
        case 'TEAM_CHANGE':
            return {
                items: [],
                fetchInfo: {
                    project: {}
                }
            };

        case 'MARK_ALL_FOR_REFETCH':
            return Object.assign({}, state, {
                items: [...state.items.map(rule => ({
                    ...rule,
                    shouldRefetch: true
                }))]
            });

        case 'RECURSION_RULE_CREATE_REQUESTED':
        case 'RECURSION_RULE_ADD_SOCKET':
            return Object.assign({}, state, {
                items: removeDupes([...state.items, action.payload.rule])
            });

        case 'RECURSION_RULE_CREATE_FAILED':
            return Object.assign({}, state, {
                items: state.items.filter(rule => rule !== action.payload.fragment)
            });

        case 'RECURSION_RULE_CREATE_SUCCEEDED':
            return Object.assign({}, state, {
                items: state.items
                    .filter(rule => rule.id !== action.payload.ruleId)
                    .map(rule => {
                        if (rule === action.payload.fragment) {
                            rule.id = action.payload.ruleId;
                        }

                        return rule;
                    })
            });

        case 'RECURSION_RULE_FETCH_REQUESTED':
            return Object.assign({}, state, {
                items: [...state.items.filter(rule => rule.id !== action.payload.ruleId), {
                    ...(state.items.find(rule => rule.id === action.payload.ruleId) || {}),
                    id: action.payload.ruleId,
                    loading: true
                }]
            });

        case 'RECURSION_RULE_FETCH_FAILED':
            return Object.assign({}, state, {
                items: [...state.items.filter(rule => rule.id !== action.payload.ruleId), {
                    id: action.payload.ruleId,
                    error: true
                }]
            });

        case 'RECURSION_RULE_FETCH_SUCCEEDED':
            return Object.assign({}, state, {
                items: [...state.items.filter(rule => rule.id !== action.payload.rule.id), action.payload.rule]
            });

        case 'RECURSION_RULE_UPDATE_REQUESTED':
        case 'RECURSION_RULE_UPDATE_SOCKET':
            return Object.assign({}, state, {
                items: [...state.items].map(rule => {
                    if (rule.id === action.payload.ruleId) {
                        return Object.assign({}, rule, cleanObject(action.payload.ruleProps || action.payload.rule));
                    }

                    return rule;
                })
            });

        case 'RECURSION_RULE_REMOVE_REQUESTED':
        case 'RECURSION_RULE_REMOVE_SOCKET':
            return Object.assign({}, state, {
                items: [...state.items].map(rule => {
                    if (rule.id === action.payload.ruleId) {
                        return {
                            id: rule.id,
                            removed: true
                        };
                    }

                    return rule;
                })
            });

        default:
            return state;
    }
}

export default rules;
